module.exports = __webpack_public_path__ + "static/media/SaifeeEvents82.1ffcc464.jpg";